module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new order-right-summary right-info-block",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.orderData.warehouse) ? _c('div', {
    staticClass: "ors-time-and-date"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Punkt podjęcia:")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.orderData.warehouse.Name) + " "), _c('br'), _vm._v(_vm._s(_vm.orderData.warehouse.Street) + " " + _vm._s(_vm.orderData.warehouse.StreetNo)), _c('br'), _vm._v("\n            " + _vm._s(_vm.orderData.warehouse.PostalCode) + " " + _vm._s(_vm.orderData.warehouse.City))])]), _vm._v(" "), (_vm.step > 2) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Adres realizacji:")]), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.orderData.address.Street) + " " + _vm._s(_vm.orderData.address.StreetNo) + " "), (_vm.orderData.address.ApartmentNo) ? _c('span', [_vm._v("/ " + _vm._s(_vm.orderData.address.ApartmentNo))]) : _vm._e(), (_vm.orderData.address.FloorNo) ? _c('span', [_vm._v(" (" + _vm._s(_vm.orderData.address.FloorNo) + " piętro)")]) : _vm._e(), _c('br'), _vm._v(_vm._s(_vm.orderData.address.PostalCode) + " " + _vm._s(_vm.orderData.address.City))])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Preferowany dzień dostawy:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.date.date))])]) : _vm._e(), _vm._v(" "), (_vm.step === 6) ? _c('div', {
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Przedział godzinowy:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.timePeriod))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderData.delivery.distance),
      expression: "orderData.delivery.distance"
    }],
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Dystans:")]), _c('em', [_vm._v(_vm._s(_vm.orderData.delivery.distance))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderData.delivery.distanceOutOfZone),
      expression: "orderData.delivery.distanceOutOfZone"
    }],
    staticClass: "col-auto"
  }, [_c('strong', [_vm._v("Dystans poza strefą:")]), _c('em', [_vm._v(_vm._s(_vm._f("formatDistance")(_vm.orderData.delivery.distanceOutOfZone)) + " km")])]), _vm._v(" "), (_vm.step > 3) ? _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Dane klienta:")]), _vm._v(" "), _c('em', [_c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.FirstName)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.LastName)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.MobilePhone)), _c('br'), _vm._v("\n                " + _vm._s(_vm.orderData.customer.Email) + "\n            ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-instruction-header"
  }, [_c('i', {
    staticClass: "ion-android-checkbox-outline header-icon"
  }), _vm._v(" "), _c('h2', [_vm._v("Podsumowanie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto col-divided"
  }, [_c('strong', [_vm._v("Typ usługi:")]), _c('em', [_vm._v("Transport")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3188b0b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SummaryBox.vue
// module id = 247
// module chunks = 1